const NameLogo = ({ size, fill }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="5.23706"
        height="2.07882"
        transform="matrix(0.880675 0.473721 -0.498843 0.866692 6.56909 3.22656)"
        fill="#BB86FC"
      />
      <rect
        width="5.60022"
        height="2.07592"
        transform="matrix(0.913993 -0.405731 0.430645 0.902522 4.90869 10.7578)"
        fill="#BB86FC"
      />
      <ellipse
        cx="3.78667"
        cy="12.022"
        rx="3.21513"
        ry="3.01419"
        fill="#BB86FC"
      />
      <ellipse
        cx="12.69"
        cy="8.2095"
        rx="3.21513"
        ry="3.01419"
        fill="#BB86FC"
      />
      <path
        d="M7.14947 1.81121C7.9741 3.31426 7.37577 5.12862 5.81306 5.86368C4.25036 6.59875 2.31505 5.97617 1.49043 4.47311C0.665802 2.97006 1.26413 1.1557 2.82684 0.420638C4.38954 -0.314426 6.32485 0.308154 7.14947 1.81121Z"
        fill="#BB86FC"
      />
    </svg>
  );
};
export default NameLogo;
